import { css } from '@emotion/react';
import { useTranslation } from '@frontend/i18n';
import { Icon } from '@frontend/icons';
import { theme } from '@frontend/theme';
import { Text } from '@frontend/design-system';
import TerminalImg from '../assets/justifi/justifi-terminal.svg?react';
import PowerOnImg from '../assets/justifi/power-on-terminal.svg?react';
import { RegisterTerminalModalJustifiSteps } from '../hooks';
import {
  RegisterTerminalStepModalWrapper,
  RegisterTerminalModalStepProps,
  RegisterTerminalStep,
} from '../register-terminal-modal-step';

const styles = {
  list: css`
    list-style-type: number;
    padding-left: ${theme.spacing(2)};
    margin-top: ${theme.spacing(2)};
    margin-bottom: ${theme.spacing(1)};
    li {
      margin-bottom: ${theme.spacing(2)};
    }
  `,
};

export const PreCheck = (props: RegisterTerminalModalStepProps) => {
  const { t } = useTranslation('payments');

  return (
    <RegisterTerminalStepModalWrapper
      title={t('Pre Check')}
      nextStep={RegisterTerminalModalJustifiSteps.TurnOnTerminal}
      nextSectionStep={RegisterTerminalModalJustifiSteps.ConnectToWifiStep1}
      Action={RegisterTerminalStep.Next}
      goBack={false}
      skipLabel={
        <>
          {t('Skip to Connect to Network')}
          <Icon name='forward-small' />
        </>
      }
      {...props}
    >
      <ol css={styles.list}>
        <li>{t('Unpack and verify contents (e285 unit, USB-C cable).')}</li>
        <li>{t('Charged battery and SIM/SAM cards already installed, to view them follow images below')}</li>
      </ol>
      <TerminalImg />
    </RegisterTerminalStepModalWrapper>
  );
};

export const PlugInTerminal = (props: RegisterTerminalModalStepProps) => {
  const { t } = useTranslation('payments');

  return (
    <RegisterTerminalStepModalWrapper
      title={t('Turn on the terminal')}
      nextStep={RegisterTerminalModalJustifiSteps.ConnectToWifiStep1}
      Action={RegisterTerminalStep.Next}
      {...props}
    >
      <div
        css={css`
          display: flex;
          justify-content: space-around;
          align-items: center;
        `}
      >
        <PowerOnImg />
      </div>
      <Text>{t('Hold the green key (power on) for 4 seconds.')}</Text>
    </RegisterTerminalStepModalWrapper>
  );
};
